import script from "./ShowEntitlementLogsDetailsModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ShowEntitlementLogsDetailsModal.vue?vue&type=script&setup=true&lang=js"

import "./ShowEntitlementLogsDetailsModal.vue?vue&type=style&index=0&id=22cfcabe&scoped=true&lang=css"
script.__scopeId = "data-v-22cfcabe"

export default script